<template></template>
<script>
  export default {
    name: 'Verify',
    created () {
      this.verify()
    },
    methods: {
      verify () {
        this.$api.post('/v1/auth/register/verify', {token: this.$route.params.token}).then(response => {
          this.$router.push('/login')
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Homepage/Verify.vue